import React from 'react';
import { Link } from 'react-router-dom';

import './css/Header.css'

import { TALK_TO_US_URL, TALK_TO_US_SHORT_LABEL, TRY_FREE_LABEL, TRY_FREE_PATH } from './contact'
import { HeroShader, DARK_PALETTE } from './HeroShader'


// The four things the hero puts forward, one per section of the page and in
// the page's order; each one scrolls to its section. Monochrome silhouettes,
// used as masks over the brand gradient. Required statically: a dynamic
// require on the images folder would make webpack bundle everything under it.
interface Pillar {
	icon: string
	label: string
	///@brief   The section's anchor, as a hash: App.tsx scrolls to it.
	to: string
}

const PILLARS: Pillar[] = [
	{ icon: require( './images/Icon.Scan.svg' ).default, label: 'Traceable copies', to: '#trace' },
	{ icon: require( './images/Icon.Stack.svg' ).default, label: 'Self-hosted', to: '#self-hosted' },
	{ icon: require( './images/Icon.Grid.svg' ).default, label: 'Very large volumes', to: '#speed' },
	{ icon: require( './images/Icon.EyeOff.svg' ).default, label: 'Invisible watermark', to: '#mark' },
]


export function Header(): React.JSX.Element {

    return (
        <div className="Header" >
            <HeroShader { ...DARK_PALETTE } />
            { /* Clears the drifting light from behind the words: the pattern
                 sinks back into the hero's black around the text, so nothing
                 crosses the letters. */ }
            <div className="Header-Scrim" aria-hidden="true" />

            <div className="Header-Container" >
                <span className="Title" data-fade data-menu-veil >An invisible mark on every image you serve.</span>
                <span className="Subtitle" data-fade data-fade-delay="0.2" >Runs on your own servers. Built for very large volumes of images.</span>

                <ul className="Header-Pillars" data-fade data-fade-delay="0.28" >
                    { PILLARS.map( ( pillar: Pillar ): React.JSX.Element => (
                        <li key={ pillar.label } >
                            <Link to={ pillar.to } className="Header-Pillar" >
                                <span
                                    className="Header-Pillar-Icon"
                                    style={ { WebkitMaskImage: `url(${ pillar.icon })`, maskImage: `url(${ pillar.icon })` } }
                                    aria-hidden="true"
                                />
                                { pillar.label }
                            </Link>
                        </li>
                    ) ) }
                </ul>

                <div className="Header-Ctas" >
                    <Link to={ TRY_FREE_PATH } className="Header-Cta Header-Cta-Primary" data-fade data-fade-delay="0.35" >{ TRY_FREE_LABEL }</Link>
                    <a href={ TALK_TO_US_URL } target="_blank" rel="noopener noreferrer" className="Header-Cta Header-Cta-Secondary" data-fade data-fade-delay="0.42" >{ TALK_TO_US_SHORT_LABEL }</a>
                </div>
            </div>
        </div>
    );

}
